import { API_BASE_URL } from '../client';

export const PROJECT_ENDPOINTS = {
  PROJECTS: {
    LIST: `${API_BASE_URL}/Project`,
    DETAIL: (id: number) => `${API_BASE_URL}/Project/${id}`,
    CREATE: `${API_BASE_URL}/Project`,
    UPDATE: (id: number) => `${API_BASE_URL}/Project/${id}`,
    REPLACE_IPD: (id: number) => `${API_BASE_URL}/Project/${id}/ipd-projects`,
    DELETE: (id: number) => `${API_BASE_URL}/Project/${id}`,
    TERMINATE: (id: number) => `${API_BASE_URL}/Project/${id}/terminate`,
    OPERATION_LOG: (id: number) => `${API_BASE_URL}/Project/${id}/operation-log`,
  },
  IPD_PROJECTS: {
    LIST: `${API_BASE_URL}/IpdProject`,
  },
  IPD_SKUS: {
    LIST: `${API_BASE_URL}/IpdSku`,
  },
  BRANDS: {
    LIST: `${API_BASE_URL}/Brand`,
  },
} as const;
